import { gsap } from 'gsap';
import { component } from 'picoapp';

const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const messages = {
  emailBlank: 'The email field cannot be blank.',
  noConsentGiven: 'Please check the box to confirm you have understood our <a class="underline" href="https://roastworks.co.uk/pages/privacy-policy">Privacy Policy</a>',
  invalidEmail: 'Please enter a valid email address.',
  success: 'Thanks for signing up!',
  failure: 'Something went wrong. Please try again.'
};

export default component((node, ) => {
  const form = node.querySelector('.js-newsletter-form');
  if (!form) return;
  const email = form.querySelector('.email');
  const consent = form.querySelector('.gdpr');
  
  let hasErrors = false;

  const validateForm = (e) => {
    if (e) e.preventDefault();
    const errors = $('.js-newsletter-field-error');
    $(errors).empty();
    hasErrors = false;

    if (email.value == '') {
      hasErrors = true;
      const html = $.parseHTML(`<p>${messages.emailBlank}</p>`);
      $('.js-email-error').html(html);

    } else if (!re.test(email.value)) { // Fails regex test
      hasErrors = true;
      const html = $.parseHTML(`<p>${messages.invalidEmail}</p>`);
      $('.js-email-error').html(html);
    }

    if (!consent.checked) {
      hasErrors = true;
      const html = $.parseHTML(`<p>${messages.noConsentGiven}</p>`);
      $('.js-consent-error').html(html);
    }

    if (hasErrors) {
      gsap.fromTo(errors,
        {
          height: 0,
          autoAlpha: 0
        },
        {
          height: 'auto',
          autoAlpha: 1,
          duration: 0.3
        });
    } else {
      submitForm();
    }

  };

  const submitForm = () => {
    const data = $(form).serialize();

    $.ajax({
      type: 'POST',
      url: $(form).attr('action'),
      data,
      dataType: 'json',
      success: () => {
        gsap.to(form, {
          opacity: 0.3,
          pointerEvents: 'none',
          cursor: 'default'
        });
        $('.js-newsletter-form-message').html($.parseHTML(`<p>${messages.success}</p>`)).show();
      },
      error: () => {
        $('.js-newsletter-form-message').html($.parseHTML(`<p>${messages.failure}</p>`)).show();
      }
    });
  };

  $(form).submit(validateForm);

});